import axios from '@/libs/axios'

export default {
  getCities() {
    return axios.get('cities')
  },
}
